import React, { useEffect, useState, Fragment } from 'react';
import AutoCompleteField from '../../components/general/fields/autoCompleteField';
import FieldText from '../../components/general/fields/fieldText';
import { IParam } from '../../../shared/types/param';
import { Grid, Button, Typography, Box } from '@mui/material';
import { useFormik } from 'formik';
import { asyncGetIdentification } from '../../../services/params.service';
import { validationsvideoCall, valuesvideoCall } from './formikData';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { IFormChat } from '../../../shared/types/chat';
import { Checkbox, FormControlLabel } from '@mui/material';
import { ToastSwal } from '../../components/general/toastSwal/toastSwal';
import { MasterMessage } from '../../../masters/masterMessages';

const VideoCall = () => {
    const { executeRecaptcha } = useGoogleReCaptcha();

    const [identifications, setIdentifications] = useState<IParam[]>([]);
    const { chat }: any = MasterMessage.auth;

    const getReCaptcha = async () => {
        try {
            if (executeRecaptcha) {
                const localToken = await executeRecaptcha('someAction');
                return localToken;
            }
        } catch (error) {
            console.error('Error al obtener reCAPTCHA:', error);
            return null;
        }
    };

    const iniciarVideollamada = (values: IFormChat) => {
        // Crear la etiqueta link para cargar el archivo CSS
        const link = document.createElement('link');
        link.setAttribute('type', 'text/css');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute(
            'href',
            'https://cmwicetex.brightpattern.com/clientweb/chat-client-v4/css/form.css'
        );
        document.head.appendChild(link);

        // Crear el objeto de configuración del chat
        const videollamadaConfig = {
            appId: process.env.REACT_APP_APP_ID_VIDEOLLAMADA,
            apiUrl: process.env.REACT_APP_API_URL,
            tenantUrl: process.env.REACT_APP_TENANT_URL,
            chatPath: process.env.REACT_APP_CHAT_PATH,
            first_name: values.name,
            last_name: values.surname,
            email: values.email,
            phone_number: values.cell,
            parameters: {
                tipoId: values.type_identification,
                numeroId: values.identification,
            },
            autostartChat: true,
            autostartVideocall: true,
        };

        // Crear la etiqueta script para cargar el archivo JavaScript
        const script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.innerHTML = `SERVICE_PATTERN_CHAT_CONFIG = ${JSON.stringify(
            videollamadaConfig
        )};`;
        document.body.appendChild(script);

        const scriptSrc = document.createElement('script');
        scriptSrc.setAttribute(
            'src',
            'https://cmwicetex.brightpattern.com/clientweb/chat-client-v4/js/init.js'
        );
        document.body.appendChild(scriptSrc);
    };

    const isFormValid = () => {
        return formik.isValid && Object.keys(formik.errors).length === 0;
    };

    const formik = useFormik({
        initialValues: valuesvideoCall,
        validationSchema: validationsvideoCall,
        onSubmit: async (formChat) => {
            const captcha = (await getReCaptcha()) || '';

            if (!captcha) {
                ToastSwal.fire({
                    text: chat,
                    icon: 'error',
                    iconColor: '#1d1d1d',
                });
            } else {
                iniciarVideollamada(formChat);
            }
        },
    });

    const getIdentifications = async () =>
        setIdentifications(await asyncGetIdentification());

    useEffect(() => {
        getIdentifications();
    }, []);

    return (
        <Box sx={{ width: '100%', maxWidth: 1500, margin: '0 auto' }}>
            <div className="container-icetex-form">
                <div className="container icetex-form">
                    <Grid container>
                        <Grid item xs={12}>
                            <div className="icetex-title-form">
                                <Typography variant="h2">
                                    Video Atención Lenguaje de Señas
                                </Typography>
                            </div>
                        </Grid>
                    </Grid>
                    <div className="icetex-container-form">
                        <Box sx={{ width: '100%' }}>
                            <div className="icetex-wecallyou-containter">
                                <Fragment>
                                    <Box mt={2} mb={2}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={6}>
                                                <Box mb={1}>
                                                    <label className="icetex-label">
                                                        Tipo de Identificación:
                                                    </label>
                                                </Box>
                                                <AutoCompleteField
                                                    data={identifications}
                                                    size="small"
                                                    label="Selecciona tu Tipo de Identificacion"
                                                    name="type_identification"
                                                    touched={
                                                        formik.touched
                                                            .type_identification
                                                    }
                                                    errors={
                                                        formik.errors
                                                            .type_identification
                                                    }
                                                    value={
                                                        formik.values
                                                            .type_identification
                                                    }
                                                    onChangeValue={(value) =>
                                                        formik.setFieldValue(
                                                            'type_identification',
                                                            value
                                                        )
                                                    }
                                                    onBlur={formik.handleBlur}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Box mb={1}>
                                                    <label className="icetex-label">
                                                        Número de documento:
                                                    </label>
                                                </Box>
                                                <FieldText
                                                    label="Identificacion"
                                                    name="identification"
                                                    type="number"
                                                    size="small"
                                                    touched={
                                                        formik.touched
                                                            .identification
                                                    }
                                                    errors={
                                                        formik.errors
                                                            .identification
                                                    }
                                                    value={
                                                        formik.values
                                                            .identification
                                                    }
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Box mb={1}>
                                                    <label className="icetex-label">
                                                        Nombres:
                                                    </label>
                                                </Box>
                                                <FieldText
                                                    label="Nombre"
                                                    name="name"
                                                    size="small"
                                                    touched={
                                                        formik.touched.name
                                                    }
                                                    errors={formik.errors.name}
                                                    value={formik.values.name}
                                                    onChange={(event) => {
                                                        const { value } =
                                                            event.target;
                                                        if (
                                                            /^[A-Za-z]*$/.test(
                                                                value
                                                            )
                                                        ) {
                                                            formik.handleChange(
                                                                event
                                                            );
                                                        }
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Box mb={1}>
                                                    <label className="icetex-label">
                                                        Apellidos:
                                                    </label>
                                                </Box>
                                                <FieldText
                                                    label="Apellido"
                                                    name="surname"
                                                    size="small"
                                                    touched={
                                                        formik.touched.surname
                                                    }
                                                    errors={
                                                        formik.errors.surname
                                                    }
                                                    value={
                                                        formik.values.surname
                                                    }
                                                    onChange={(event) => {
                                                        const { value } =
                                                            event.target;
                                                        if (
                                                            /^[A-Za-z]*$/.test(
                                                                value
                                                            )
                                                        ) {
                                                            formik.handleChange(
                                                                event
                                                            );
                                                        }
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Box mb={1}>
                                                    <label className="icetex-label">
                                                        Correo:
                                                    </label>
                                                </Box>
                                                <FieldText
                                                    label="Correo Usuario"
                                                    name="email"
                                                    size="small"
                                                    touched={
                                                        formik.touched.email
                                                    }
                                                    errors={formik.errors.email}
                                                    value={formik.values.email}
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Box mb={1}>
                                                    <label className="icetex-label">
                                                        Teléfono fijo o celular:
                                                    </label>
                                                </Box>
                                                <FieldText
                                                    label="Teléfono fijo o celular"
                                                    name="cell"
                                                    type="tel"
                                                    size="small"
                                                    touched={
                                                        formik.touched.cell
                                                    }
                                                    errors={formik.errors.cell}
                                                    value={formik.values.cell}
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            className="checkbox_boot"
                                                            id="policy"
                                                            name="aceptoPolitica"
                                                            checked={
                                                                formik.values
                                                                    .acceptPolicy
                                                            }
                                                            onChange={() => {
                                                                formik.setFieldValue(
                                                                    'acceptPolicy',
                                                                    !formik
                                                                        .values
                                                                        .acceptPolicy
                                                                );
                                                            }}
                                                            onBlur={
                                                                formik.handleBlur
                                                            }
                                                        />
                                                    }
                                                    label={
                                                        <a
                                                            target="_blank"
                                                            href="https://web.icetex.gov.co/atencion-al-ciudadano/politica-de-tratamiento-de-datos-personales"
                                                        >
                                                            Acepto la política
                                                            de privacidad y uso
                                                            de datos personales
                                                        </a>
                                                    }
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sx={{ textAlign: 'center' }}
                                            >
                                                <Button
                                                    variant="contained"
                                                    type="submit"
                                                    className="icetex-btn-primary"
                                                    disabled={!isFormValid()}
                                                    onClick={() =>
                                                        formik.handleSubmit
                                                    }
                                                >
                                                    Iniciar Chat
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Fragment>
                            </div>
                        </Box>
                    </div>
                </div>
            </div>
        </Box>
    );
};

export default VideoCall;
